import SectionFeaturedProducts from './SectionFeaturedProducts';

export default SectionFeaturedProducts;
